import type { JSX } from 'react';
import React from 'react';
import type { SingleValueProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import type { IObjectiveOptionWithIcon } from '@feathr/extender/hooks';

import * as styles from './ObjectiveValue.css';

function ObjectiveValue(props: Readonly<SingleValueProps<IObjectiveOptionWithIcon>>): JSX.Element {
  const { data } = props;

  return (
    <components.SingleValue {...props}>
      <div className={styles.root}>
        <div>{data.icon}</div>
        <span className={styles.label}>{data.name}</span>
      </div>
    </components.SingleValue>
  );
}

export default ObjectiveValue;
